import { useEffect, useState } from 'react';
import Head from 'next/head';
import styles from './style.module.css';
import { Icon } from 'semantic-ui-react';
import data from './data.json'
import Link from 'next/link';

export default function FaqSimple({ questionsAndAnswers = data, noReadMore, title = "Frequently Asked Questions" }) {
  const [active, setActive] = useState(-1);
  const clickHandler = (index) => () => {
    if (active === index) {
      setActive(-1);
    } else {
      setActive(index);
    }
  }
  return (
    <div className={styles.container}>
        <div className={styles.title}>
            <h2>{title}</h2>
        </div>

        {questionsAndAnswers.map((item, index) => (
            <div className={`${styles.item} ${active === index ? styles.open : ''}`} key={index} onClick={clickHandler(index)}>
                <div className={styles.control}>
                    {item.question}
                </div>
                {index === active ? (
                    <div className={`${styles.panel} ${styles.open}`}>
                    {item.answer}
                </div>
                ) : null}
                <ChevronIcon open={index === active} key={index} />
            </div>
        ))}
        {
            noReadMore ? null : (
                <div className={styles.readMore}>
                    <Link href="/help/categories/faqs"><a>Read more FAQs</a></Link>
                </div>
            )
        }
    </div>

  );
}

function ChevronIcon({open}) {
    const [transitioning, setTransitioning] = useState(false);
    const [openVal, setOpenVal] = useState(open);

    useEffect(() => {
        if (open !== null && openVal !== open) {
            setTransitioning(true);
            setTimeout(() => {
                setTransitioning(false);
                setOpenVal(open);
            }, 10)
        }
    }, [open]) 

    if (transitioning) {
        return null;
    }

    return (
        <div className={styles.icon}>
            <Icon size={'small'} name={open ? 'chevron up' : 'chevron down'} />
        </div>
    )
}

export const FAQUpdated = ({ questionsAndAnswers, title }) => {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": questionsAndAnswers.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.answer
            }
        }))
    };

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
                />
            </Head>
            <div className="faq-section m-8 mt-20 max-w-6xl mx-auto" style={{color: '#333333'}}>
                <h2 className="text-center">{title}</h2>
                {questionsAndAnswers.map((item, index) => (
                    <div className="faq-item mt-10" key={index}>
                        <h3>{item.question}</h3>
                        <p>{item.answer}</p>
                    </div>
                ))}
            </div>
        </>
    )
}
